import { IJupyterWidgetRegistry } from '@jupyter-widgets/base';
import { DisposableDelegate } from '@lumino/disposable';
import { ContextManager } from './manager';
import { BokehJSExec, BokehJSLoad, BOKEHJS_EXEC_MIME_TYPE, BOKEHJS_LOAD_MIME_TYPE } from './renderer';
export class NBWidgetExtension {
    createNew(nb, context) {
        const manager = new ContextManager(context);
        nb.content.rendermime.addFactory({
            safe: false,
            mimeTypes: [BOKEHJS_LOAD_MIME_TYPE],
            createRenderer: options => new BokehJSLoad(options)
        }, 0);
        // the rank has to be -1, so that the priority is higher than the
        // default javascript mime extension (rank=0)
        nb.content.rendermime.addFactory({
            safe: false,
            mimeTypes: [BOKEHJS_EXEC_MIME_TYPE],
            createRenderer: options => new BokehJSExec(options, manager)
        }, -1);
        return new DisposableDelegate(() => {
            if (nb.content.rendermime) {
                nb.content.rendermime.removeMimeType(BOKEHJS_EXEC_MIME_TYPE);
            }
            manager.dispose();
        });
    }
}
import { name, version } from './metadata';
import { BokehModel, BokehView } from './widgets';
export const extension = {
    id: name,
    requires: [IJupyterWidgetRegistry],
    activate: (app, widgets) => {
        // this adds the Bokeh widget extension onto Notebooks specifically
        app.docRegistry.addWidgetExtension('Notebook', new NBWidgetExtension());
        widgets.registerWidget({
            name,
            version,
            exports: {
                BokehModel: BokehModel,
                BokehView: BokehView
            }
        });
    },
    autoStart: true
};
